export default {
  heading: 'Thank you for using Cheerie!',
  reinstall: "Changed your mind? Let's take you back home!",
  help: 'Help us improve!',
  question:
    'Why did you decide to delete your Cheerie account? Check all that apply.',
  improve: 'How can we improve Cheerie?',
  selectReason: 'Please select at least one reason',
  thanks: 'Thank you for your feedback!',
  toHome: 'Search Now',
};
